export default function(total) {
    if (total == null) {
        return '00:00';
    }
    const hours = Math.floor(total / 60);
    const minutes = total % 60;
    return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
}
